import { AfterViewInit, Directive, ElementRef, HostBinding, Input, Renderer2 } from '@angular/core';
import { ContentEnum, GridCell, GridCellClass } from '../../models/sections-model';

@Directive({
  selector: '[kweOptionalClasses]'
})
export class OptionalClassesDirective implements AfterViewInit {
  @Input() gridCell:GridCell;
  layoutClass:string;
  themeClass:string;

  @HostBinding("style.--cell-background-color") bgColor:string = "transparent";
  
  constructor(private el:ElementRef<HTMLElement>,private renderer2:Renderer2) { }
  ngAfterViewInit(): void {
    //console.log(this.gridCell)
    if(this.gridCell.layoutClass != undefined && this.gridCell.layoutClass != null){
      let clsEnum;
      if((this.gridCell.layoutClass).includes(".")){
        let enumKey = this.gridCell.layoutClass.split('.')[1] as keyof typeof GridCellClass;
        clsEnum = GridCellClass[enumKey];
      }else if(GridCellClass[this.gridCell.layoutClass] != undefined){
        clsEnum = GridCellClass[this.gridCell.layoutClass]
      }else{
        clsEnum = this.gridCell.layoutClass;
      }
      this.layoutClass = clsEnum.toLowerCase();
      console.log(this.layoutClass);
      //this.layoutClass = this.gridCell.layoutClass;
      this.renderer2.addClass(this.el.nativeElement,this.layoutClass);
    }
    if(this.gridCell.themeClass != undefined && this.gridCell.themeClass != null){
      this.themeClass = this.gridCell.themeClass;
      this.renderer2.addClass(this.el.nativeElement,this.themeClass);
    }
    if(this.gridCell.bgColor != undefined){
      console.log(this.gridCell.bgColor);
      this.bgColor = this.gridCell.bgColor;
    }
    if(this.gridCell.contentEnum != undefined){
      /**
       * Because contentEnum is captured in various way, we need to get a standard way of getting the value.
       * The best practice is to store the contentEnum by key on, but since we have both key and value  and the dot notation
       * we have to do this to get values only
       */
      let cntEnum;
      if((this.gridCell.contentEnum).includes(".")){
        let enumKey = this.gridCell.contentEnum.split('.')[1] as keyof typeof ContentEnum;
        cntEnum = ContentEnum[enumKey];
      }else if(ContentEnum[this.gridCell.contentEnum] != undefined){
        cntEnum = ContentEnum[this.gridCell.contentEnum]
      }else{
        cntEnum = this.gridCell.contentEnum;
      }
      /**
       * Resolve contentEnum by value
       */
      //switch (this.gridCell.contentEnum)
      switch (cntEnum) {
        case  "Product Content":
          this.renderer2.addClass(this.el.nativeElement,"product-content");
          break;
        case  "Category Content":
          this.renderer2.addClass(this.el.nativeElement,"category-content");
          break;
        case  "Promotional Text":
          this.renderer2.addClass(this.el.nativeElement,"promotional-text");
          break;
        case  "Call To Action":
          this.renderer2.addClass(this.el.nativeElement,"call-to-action");
          this.renderer2.setAttribute(this.el.nativeElement,"content","call-to-action");
          break;
        case  "Blog Article Link":
          this.renderer2.addClass(this.el.nativeElement,"blog-article-link");
          break;
        case  "Category Link":
          this.renderer2.addClass(this.el.nativeElement,"category-link");
          break;
        case  "Product Link":
          this.renderer2.addClass(this.el.nativeElement,"product-link");
          this.renderer2.setAttribute(this.el.nativeElement,"content","product-link");
          break;
        case  "Banner":
          this.renderer2.addClass(this.el.nativeElement,"banner");
          this.renderer2.setAttribute(this.el.nativeElement,"content","banner");
          break;
        case "Hero Image":
          this.renderer2.addClass(this.el.nativeElement,"hero-image-cell");
          this.renderer2.setAttribute(this.el.nativeElement,"content","image");
          break;
        case "Headline":
          this.renderer2.addClass(this.el.nativeElement,"headline");
          this.renderer2.setAttribute(this.el.nativeElement,"content","headline");
          break;
        case "Sub Headline":
          this.renderer2.addClass(this.el.nativeElement,"sub-headline");
          this.renderer2.setAttribute(this.el.nativeElement,"content","sub-headline");
          break;
            
        default:
          /**
           * resolve contentEnum by key
           */
          //let rendererType = data.rendererType;
          
          break;
      }
    }
  }


}
